<template>
    <v-app style="background-color: #F5F7F9;">
        <v-main style="background-color: #F5F7F9;">
            <component :is="layout">
                <router-view :key="$route.fullPath + '|' + $tz.display()" />
            </component>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: 'App',
    computed: {
        layout() {
            return (this.$route.meta.layout || 'blank') + '-layout'
        },
    },
}
</script>

<style>
/* Fix: Vuetify 2 centers dialogs vertically, so tall dialogs overflow above the viewport
   and the top (title) becomes unreachable. Align to flex-start + padding so the dialog
   always starts near the top and remains fully scrollable. */
.v-dialog__content {
    align-items: flex-start !important;
    padding-top: 70px !important;
    /* padding-bottom: 24px !important; */
    overflow-y: auto !important;
}

/* --- Mobile: let desktop-sized page containers fit the phone --- */
@media (max-width: 959px) {
    /* Many pages hard-code an inline min-width (e.g. 1200px) for their desktop
       grid. On a phone that forces a horizontal scroll and shoves the sticky
       header off-screen. Collapse it so the page reflows. */
    [style*="min-width: 1200px"],
    [style*="min-width:1200px"],
    [style*="min-width: 1300px"],
    [style*="min-width: 1400px"] {
        min-width: 0 !important;
        max-width: 100% !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
    }

    /* Safety net so no stray wide child can scroll the whole document sideways
       (which is what detaches the sticky top nav on mobile). */
    html,
    body {
        overflow-x: hidden;
    }
}
</style>